/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const searchHubSpotCompanyDataSchema = z.object({
	q: z.string(),
})

export type SearchHubSpotCompanyDataSchema = z.infer<typeof searchHubSpotCompanyDataSchema>
